module.exports = __webpack_public_path__ + "img/startImg.5ac489f5.png";